<template>
    <div>
        <a-card>

            <a-tabs>
                <a-tab-pane v-for="it in packsList" :key="it.id" :tab="it.alisName">
                    <div class="text-center mb-5">
                        <a-button type="primary" style="width: 200px" v-if="it.signUpState === 1" disabled>已报名</a-button>
                        <a-button type="primary" style="width: 200px" v-if="it.signUpState === 0" @click="onSignPermission">立即报名</a-button>
                        <a-button v-if="it.signUpState === 2"  style="width: 200px" >报名已截止</a-button>
                    </div>
                    <table class="fx-form-view">
                        <tr>
                            <th>包组名称</th>
                            <td>
                                <B>
                                    {{it.packName}}
                                </B>
                            </td>
                            <th>包组编号</th>
                            <td>
                                {{it.packCode}}
                            </td>
                        </tr>

                        <tr>
                            <th>竞价方式</th>
                            <td>
                            <B>
                                <span v-if="it.compWay === '1'">
                                    自由竞价
                                </span>
                                <span v-else-if="it.compWay === '2'">
                                    单轮竞价
                                </span>
                                <span v-else-if="it.compWay === '3'">
                                    多轮竞价
                                </span>
                                &nbsp;&nbsp; - &nbsp;&nbsp;
                                {{it.compType === '1' ? '竞高价' : '竞低价'}}
                            </B>
                            </td>
                            <th>竞价开始时间</th>
                            <td>
                                {{formatDate(it.openTime) }}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                竞价时长
                            </th>
                            <td>
                                {{it.duration}} 分钟
                            </td>
                            <th>
                              <span v-if="it.compWay === '1'">
                                竞价倒计时长
                              </span>
                            </th>
                            <td>
                            <span v-if="it.compWay === '1'">
                            {{it.countDown}} 分钟
                             </span>
                             <span v-else>
                              {{ it.offerType === '2' ? '折扣率' : it.offerType === '3' ? '下浮率' : '金额' }}
                              </span>
                            </td>
                        </tr>
                        <tr v-if="it.compWay === '1'">
                            <th>
                                报价类型
                            </th>
                            <td colspan="3">
                                {{ it.offerType === '2' ? '折扣率' : it.offerType === '3' ? '下浮率' : '金额' }}
                            </td>
                        </tr>
                        <tr>
                          <template v-if="it.offerType === '2' || it.offerType === '3'">
                            <th>
                              限价
                            </th>
                            <td>
                              {{it.priceStart? it.offerType === '2'?(it.priceStart * 100)+'%-100%':'0%-'+(it.priceStart * 100)+'%':'0%-100%'}}
                            </td>
                            <th>
                                <span v-if="it.compWay === '1'">
                                    {{it.compType === '1' ? '加价幅度' : '减价幅度'}}
                                </span>
                            </th>
                            <td>
                                <span v-if="it.compWay === '1'">
                                    {{ it.pricePer && (it.pricePer * 100) }} %
                                </span>
                            </td>
                          </template>
                          <template v-else>
                            <th>
                              {{it.compType === '1' ? '最低限价' : '最高限价'}}
                            </th>
                            <td>
                                {{it.priceStart}} 元
                            </td>
                            <th>
                                <span v-if="it.compWay === '1'">
                                    {{it.compType === '1' ? '加价幅度' : '减价幅度'}}
                                </span>
                            </th>
                            <td>
                                <span v-if="it.compWay === '1'">
                                    {{it.pricePer}} 元
                                </span>
                            </td>
                          </template>
                        </tr>
                        <tr>
                            <th>废标条件</th>
                            <td colspan="3" style="color: dimgray;padding-left: 20px;">
                                参与报名供应商数量少于 <B>{{it.leastSupNum}}</B> 家;
                                <br>
                                参与报价供应商少于 <B>{{it.joinSupNum}}</B> 家;
                            </td>
                        </tr>
                        <tr>
                            <th>说明</th>
                            <td colspan="3">
                                {{it.otherRemarks}}
                            </td>
                        </tr>
                    </table>

                    <a-col :span="24">
                        <a-divider class="color-orange mt-6" size="small"  orientation="left">标的物信息
                        </a-divider>
                    </a-col>

                    <a-table  style="width: 100%"
                              :dataSource="it.subjectList"
                              :rowKey="record => record.id"
                              :pagination="false">
                        <a-table-column  key="subjectName" width="20%" title="名称" data-index="subjectName">
                            <template slot-scope="text,record">
                                {{record.subjectName}}
                            </template>
                        </a-table-column>
                        <a-table-column v-if="tenderType==='1'" key="specifications" width="20%" title="品牌及规格型号"
                                        data-index="specifications">
                            <template slot-scope="text,record">
                                {{record.specifications}}
                            </template>
                        </a-table-column>

                        <a-table-column v-if="tenderType==='1'" key="quantity" width="10%" title="数量" data-index="quantity">
                            <template slot-scope="text,record">
                                {{record.quantity}}
                            </template>
                        </a-table-column>
                        <a-table-column v-if="tenderType==='1'" key="unit" width="10%" title="单位" data-index="unit">
                            <template slot-scope="text,record">
                                {{record.unit}}
                            </template>
                        </a-table-column>
                        <a-table-column v-if="tenderType!=='1'" key="serviceScope" width="25%" :title="(tenderType!=='1' && tenderType==='2')?'施工范围':'简要服务内容'" data-index="serviceScope">
                            <template slot-scope="text,record">
                                {{record.serviceScope}}
                            </template>
                        </a-table-column>
                        <a-table-column v-if="tenderType==='2' || tenderType==='3'" key="servicePeriod" width="15%" :title="(tenderType!=='1' && tenderType==='2')?'施工工期':'服务期限'" data-index="servicePeriod">
                            <template slot-scope="text,record">
                                {{record.servicePeriod}}
                            </template>
                        </a-table-column>
                        <a-table-column key="ask" width="25%" title="其他要求" data-index="ask">
                            <template slot-scope="text,record">
                                {{record.ask}}
                            </template>
                        </a-table-column>
                    </a-table>

                </a-tab-pane>
            </a-tabs>
        </a-card>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        name: "PacksInfo",
        components: {},
        created() {
            this.initPacks()
        },
        mounted() {
        },
        props: {
            projectId: {
                type: String,
                required: true
            },
            random: {
                type:String,
                default: '',
                required: false
            },
            tenderType: {
                type:String,
                default: '',
                required: false
            }
        },
        watch: {
            random: {
                immediate: false,
                handler(newValue,oldValue) {
                    if (newValue !== oldValue) {
                        // console.log("has listened data!")
                        this.initPacks()
                    }
                }
            }
        },
        data() {
            return {
                packsList: [],
                columns: [
                    {
                        title: '名称',

                        scopedSlots: { customRender: 'subjectName' }
                    },
                    {
                        title: '规格型号',

                        scopedSlots: { customRender: 'specifications' }
                    },
                    {
                        title: '数量',
                        scopedSlots: { customRender: 'quantity' },

                    },
                    {
                        title: '单位',
                        scopedSlots: { customRender: 'unit' },

                    },
                    {
                        title: '其他要求',
                        scopedSlots: { customRender: 'ask' },

                    },
                    {
                        title: '备注',
                        scopedSlots: { customRender: 'remarks' },

                    }
                ],
            }
        },
        methods: {
            formatDate(value) {
                if (!value){
                    return "未设置时间"
                }
                value = value.replace(new RegExp(/-/gm) ,"/")
                value = moment(new Date(value)).format("YYYY/MM/DD HH:mm")
                return value
            },
            tt() {
                this.random = Math.random()*1000*1000*1000*1000*1000*1000 +""
            },
            // initPacks() {
            //     let that = this
            //     this.$http.get("/api/v1/supplier/packs/getPacks.json?projectId=" + this.projectId).then(function (res) {
            //         // console.log(res)
            //         that.packsList = res.result
            //         for (let i = 0; i < that.packsList.length; i++) {
            //             var item = that.packsList[i]
            //             var code =  that.packsList[i].packCode
            //             var newNo = code.substring(code.length-1,code.length)
            //             // console.log(newNo)
            //             that.packsList[i].title = "包组" + newNo
            //             // that.packsList[i].extras.openTime =  that.packsList[i].extras.openTime.replace(new RegExp(/-/gm) ,"/")
            //             // that.packsList[i].extras.openTime = moment(new Date(that.packsList[i].extras.openTime)).format("YYYY/MM/DD HH:mm")
            //         }
            //     });
            // },
            initPacks() {
                let that = this
                this.$http.get("/api/v1/supplier/packs/getPacksList/" + this.projectId).then(function (res) {
                    if(res.code === 200){
                        that.packsList = res.result
                    }
                    // // console.log(res)
                    // that.packsList = res.result
                    // for (let i = 0; i < that.packsList.length; i++) {
                    //     var item = that.packsList[i]
                    //     var code =  that.packsList[i].packCode
                    //     var newNo = code.substring(code.length-1,code.length)
                    //     that.packsList[i].title = "包组" + newNo
                    // }
                });
            },
            showConfirm(value) {
                let that = this
                this.$confirm({
                    title: "提示",
                    content: value,
                    okText: '去认证',
                    cancelText: '取消',
                    onOk() {
                        that.$http.get('/api/v1/supplier/getAccountInfo.json').then(function (res) {
                            that.$router.push({path: '/enterprise/CertificationIndex'});
                            // console.log(res);
                            // if (res.result.supplierType === '1') {
                            //     that.$router.push({path: '/enterprise/NatureAuth'})
                            // }else if (res.result.supplierType === '2') {
                            //     that.$router.push({path: '/enterprise/EnterpriseAuth'});
                            // }
                        });
                    },
                    onCancel() {
                    }
                });
            },
            sign() {
                this.$router.push({path: '/SignIndex?id=' + this.projectId})
            },
            onSignPermission() {
                let that = this
                this.$http.get('/api/v1/supplier/sign/signPermission.json?projectId=' + this.projectId).then(function (data) {
                    if (data.code === 100) {
                        that.$error({
                            title: '提示',
                            content: data.msg,
                            okText: '确定',
                            onOk() {
                            }
                        })
                    } else if (data.code === 300) {
                        that.showConfirm(data.msg)
                    }else if(data.code === 301){
                        that.$confirm({
                            title: "提示",
                            content: data.msg,
                            okText: '立即认证',
                            cancelText: '继续报名',
                            onOk() {
                                that.$http.get('/api/v1/supplier/getAccountInfo.json').then(function (res) {
                                    that.$router.push({path: '/enterprise/LegalCertificationIndex'});
                                });
                            },
                            onCancel() {
                                that.sign()
                            }
                        });
                    } else if (data.code === 200) {
                        that.sign()
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .fx-form-view th {
        border: 1px solid #e6e6e6;
        background-color: #f7f7f7;
    }
    .fx-form-view td {
        border: 1px solid #e6e6e6;
    }
    .fx-form-view{
        table-layout: auto;
    }
</style>
